import { Beer, CarFront, Coffee, Croissant, Flame, IceCreamCone, Utensils, UtensilsCrossed } from 'lucide-react';
import { isBar, kindLabel } from '../lib/places';
import type { PlaceKind } from '../lib/types';

const ICONS: Partial<Record<PlaceKind, typeof Beer>> = {
  Bar: Beer,
  Diner: UtensilsCrossed,
  Bbq: Flame,
  Cafe: Coffee,
  DriveIn: CarFront,
  Bakery: Croissant,
  IceCream: IceCreamCone,
};

export function KindIcon({ kind, size = 14 }: { kind: PlaceKind; size?: number }) {
  const Icon = ICONS[kind] ?? Utensils;
  return <Icon size={size} aria-hidden />;
}

/** "Bar" in amber, a bite ("Diner", "BBQ"...) in the bites' warm red, matching the map pins. */
export default function KindChip({ kind }: { kind: PlaceKind }) {
  return (
    <span className={`chip font-semibold ${isBar(kind) ? 'text-amber-hi' : 'text-bite'}`}>
      <KindIcon kind={kind} />
      {kindLabel(kind)}
    </span>
  );
}
